module.exports = __webpack_public_path__ + "media/images/logo-white-b08c664fe4a2118585188486645cdb46.svg";